import { useEffect, useState } from "react";
import useDataFetch, {
  DataFetchOptionsType,
} from "../../../../hooks/useDataFetch";
import RenderGrid from "./partials/renderGrid";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";
import { apiService } from "../../services/apiService";
import { useParams } from "react-router-dom";
import { updateSkillsDistribution } from "../../../../store/steps/stepTwoSlice";
import { useDispatch } from "react-redux";

const StepTwo = () => {
  const dispatch = useDispatch();
  const { assessmentId } = useParams();
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
    req: assessmentId,
  });

  const { loading, data, error } = useDataFetch(
    apiService.getTopics,
    fetchOptions
  );

  const handleUpdateTopicsData = (updatedTopics) => {
    dispatch(updateSkillsDistribution(updatedTopics));
  };

  useEffect(() => {
    if (data?.topics) {
      handleUpdateTopicsData(data.topics);
    }
  }, [data]);

  if (loading) {
    return <RenderLoading />;
  }

  if (error) {
    return (
      <RenderError
        error={error}
        onRetry={() => {
          setFetchOptions((prev) => ({
            ...prev,
            requestId: new Date().getTime().toString(),
          }));
        }}
      />
    );
  }

  if (data) {
    return <RenderGrid />;
  }

  return null;
};

export default StepTwo;
